import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-quotes',
  templateUrl: './quotes.component.html',
  styleUrls: ['./quotes.component.css']
})
export class QuotesComponent implements OnInit {

  computeQuoteForm: FormGroup;
  modelSettingForm: FormGroup;
  showModelSettingsDescription = false;
  showResult = false;

  // Result
  originQuote = '';
  destinationQuote = '';
  distanceQuote = '';
  priorityQuote = '';
  assuranceQuote = '';
  weightQuote = '';
  commodityQuote = '';
  declaredValueQuote = '';
  truckQuote = '';
  truckMarketPriceQuote = '';

  totalQuote = 0;

  /** Model Weights */
  modelW1PricePerKm = '';
  modelW2PriceForTruckOccupationFull = '';
  modelW3PriceForTruckOccupationHalf = '';
  modelW4PriceForAssurance = '';
  modelW5PriceForKg = '';
  modelW6PriceForHighPriority = '';
  modelW7PriceForMediumPriority = '';
  modelW8PriceForLowPriority = '';
  modelW9PercentageProfit = '';

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.computeQuoteForm = this.formBuilder.group({
      origin: [''],
      destination: [''],
      priority: [''],
      assurance: [''],
      weight: [''],
      commodity: [''],
      declaredValue: [''],
      truck: [''],
      truckMarketPrice: ['']
    });

    this.setInitialWeightsToModel();
  }

  get f() { return this.computeQuoteForm.controls; }

  onComputeQuote() {
    const origin = this.computeQuoteForm.get('origin').value;
    const destination = this.computeQuoteForm.get('destination').value;
    const priority = this.computeQuoteForm.get('priority').value;
    const assurance = this.computeQuoteForm.get('assurance').value;
    const weight = this.computeQuoteForm.get('weight').value;
    const commodity = this.computeQuoteForm.get('commodity').value;
    const declaredValue = this.computeQuoteForm.get('declaredValue').value;
    const truck = this.computeQuoteForm.get('truck').value;
    const truckMarketPrice = this.computeQuoteForm.get('truckMarketPrice').value;

    console.log('origin:', origin, 'destination:', destination,
      'priority:', priority, 'assurance:', assurance, 'weight:', weight,
      'commodity:', commodity, 'declaredValue:', declaredValue, 'truck:', truck,
      'truckMarketPrice', truckMarketPrice);

    this.showResult = true;

    this.originQuote = origin;
    this.destinationQuote = destination;
    this.distanceQuote = '' + this.calculateDistanceBetweenCities(origin, destination);
    this.priorityQuote = priority;
    this.assuranceQuote = assurance;
    this.weightQuote = weight;
    this.commodityQuote = commodity;
    this.declaredValueQuote = declaredValue;
    this.truckQuote = truck;
    this.truckMarketPriceQuote = truckMarketPrice;

    if (this.originQuote && this.destinationQuote && this.distanceQuote && this.priorityQuote
    && this.assuranceQuote && this.weightQuote && this.commodityQuote && this.declaredValueQuote
    && this.truckQuote && this.truckMarketPriceQuote &&
      this.originQuote !== '' && this.destinationQuote !== ''  && this.distanceQuote !== ''  && this.priorityQuote !== ''
      && this.assuranceQuote !== ''  && this.weightQuote !== ''  && this.commodityQuote !== ''  && this.declaredValueQuote !== ''
      && this.truckQuote !== ''  && this.truckMarketPriceQuote !== '' ) {
      this.predictTotalQuote();
    }

  }

  showSettingsDescription(show: boolean) {
    this.showModelSettingsDescription = show;
  }

  setInitialWeightsToModel() {
    this.modelW1PricePerKm = '100';
    this.modelW2PriceForTruckOccupationFull = '300';
    this.modelW3PriceForTruckOccupationHalf = '180';
    this.modelW4PriceForAssurance = '200';
    this.modelW5PriceForKg = '5';
    this.modelW6PriceForHighPriority = '100';
    this.modelW7PriceForMediumPriority = '50';
    this.modelW8PriceForLowPriority = '0';
    this.modelW9PercentageProfit = '26';
  }

  predictTotalQuote() {
    const w1 = +this.modelW1PricePerKm;
    const w2 = this.priorityQuote === 'HIGH' ? this.modelW6PriceForHighPriority :
      this.priorityQuote === 'MEDIUM' ? this.modelW7PriceForMediumPriority : this.modelW8PriceForLowPriority;
    const w3 = this.assuranceQuote === 'Y' ? this.modelW4PriceForAssurance : '0';
    const w4 = this.modelW5PriceForKg;
    const w5 = this.truckQuote === 'Y' ? this.modelW2PriceForTruckOccupationFull : this.modelW3PriceForTruckOccupationHalf;
    const w6 = +this.modelW9PercentageProfit / 100; // convert to %
    console.log('w1:', w1);

    const distance = this.calculateDistanceBetweenCities(this.originQuote, this.destinationQuote);

    this.totalQuote = + ( (w1 * distance) + (+w2 * 1) + (+w3 * 1) + (+w4 * +this.weightQuote) + (+w5) );
    this.totalQuote = this.totalQuote + (w6 * this.totalQuote);
    console.log('this.totalQuote:', this.totalQuote);
  }

  calculateDistanceBetweenCities(origin: string, destination: string) {
    if (origin === null || origin === undefined ||
      destination === null || destination === undefined) {
      return 1;
    }

    if (origin.length > 0 && origin.length < 4) { // Just for simulating from form
      return +origin;
    }

    const sumCharacteres = origin.length + destination.length;
    const random = this.getRandomInt(1, sumCharacteres);
    return sumCharacteres * random;
  }

  getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
  }

}
